export default (purchasePrice, salePrice) => {
  let porcentajeGanancia = 0;
  // Calcular el porcentaje de ganancia
  porcentajeGanancia = ((salePrice - purchasePrice) / purchasePrice) * 100;

  return Math.round(porcentajeGanancia);
};
